function anti_shake(config, axios) {

    const now_date = new Date().getTime();

    const request_info = JSON.parse(sessionStorage.getItem("request_url"));

    sessionStorage.setItem(
        "request_url",
        JSON.stringify({
            url: config.url,
            time: new Date().getTime()
        })
    );

    // console.log(request_info);

    if (request_info === null) return true;

    // 允许该 url 通过过滤
    if (request_info.url === "/ascancer/api/gencode/genename/") {
        return true
    }

    // if (request_info.url === "/ascancer/api/geneinfo/allgene/") {
    //     return true
    // }

    if (now_date - request_info.time < 500 && request_info.url === config.url) {

        let cancel;
        config.cancelToken = new axios.CancelToken((c) => {
            cancel = c;
        });
        cancel(`${config.url}请求被中断`);

        return false;
    }
    return true;
}

export default anti_shake;